import Fuse from "fuse.js";

const SELECTORS = {
  SEARCH_INPUT: "search__input",
  SEARCH_BUTTON: "search__button",
  SEARCH_CLEAR: "search__clear",
  DOCUMENTS_ITEMS: "documents__item",
  DOCUMENTS_TITLE: "documents__item-title",
  DOCUMENTS_CATEGORY: "documents__category",
  NO_RESULTS: "documents__no-results",
};

export class DocumentsSearch {
  constructor() {
    this.searchInput = document.getElementById("search-input");
    this.searchButton = document.getElementById("search-button");
    this.clearButton = document.getElementById("search-clear");
    this.documentsItems = document.querySelectorAll(
      `.${SELECTORS.DOCUMENTS_ITEMS}`,
    );
    this.documentsCategories = document.querySelectorAll(
      `.${SELECTORS.DOCUMENTS_CATEGORY}`,
    );

    this.documentsData = this.prepareDocumentsData();
    this.fuse = this.initializeFuse();
    this.isSearchActive = false;

    this.init();
  }

  init() {
    this.setEventListeners();
    this.createNoResultsElement();
    this.handleUrlHash();
  }

  handleUrlHash() {
    const urlParams = new URLSearchParams(window.location.search);
    const groupParam = urlParams.get("group");
    if (!groupParam) return;

    const targetCategory = document.getElementById(groupParam);

    if (targetCategory) {
      setTimeout(() => {
        const headerOffset = 100;
        const elementPosition = targetCategory.getBoundingClientRect().top;
        const offsetPosition =
          elementPosition + window.pageYOffset - headerOffset;

        window.scrollTo({
          top: offsetPosition,
          behavior: "smooth",
        });
      }, 400);
    }
  }

  setEventListeners() {
    this.searchInput.addEventListener("input", (e) => this.handleSearch(e));
    this.clearButton.addEventListener("click", () => this.clearSearch());
  }

  prepareDocumentsData() {
    const data = [];
    this.documentsItems.forEach((item, index) => {
      const title =
        item.querySelector(`.${SELECTORS.DOCUMENTS_TITLE}`)?.textContent || "";

      data.push({
        index,
        title: title.trim(),
        element: item,
      });
    });
    return data;
  }

  initializeFuse() {
    const options = {
      keys: [
        {
          name: "title",
          weight: 1,
        },
      ],
      threshold: 0.3, // Чувствительность поиска (0 = точное совпадение, 1 = любое совпадение)
      includeScore: true,
      minMatchCharLength: 2,
      ignoreLocation: true,
    };

    return new Fuse(this.documentsData, options);
  }

  handleSearch(event) {
    const query = event.target.value.trim();

    if (query.length === 0) {
      this.clearSearch();
      return;
    }

    // Показываем кнопку очистки и скрываем кнопку поиска
    this.showClearButton();
    this.hideSearchButton();

    if (query.length < 2) {
      return; // Не ищем, если меньше 2 символов
    }

    this.isSearchActive = true;
    this.performSearch(query);
  }

  performSearch(query) {
    const results = this.fuse.search(query);
    console.log(results, query);
    this.displayResults(results);
  }

  displayResults(results) {
    // Скрываем все элементы DOCUMENTS
    this.documentsItems.forEach((item) => {
      item.style.display = "none";
    });

    if (results.length === 0) {
      this.showNoResults();
      this.updateCategoriesVisibility();
      return;
    }

    this.hideNoResults();

    // Показываем только найденные элементы
    results.forEach((result) => {
      const item = result.item.element;
      item.style.display = "flex";
    });

    // Обновляем видимость категорий
    this.updateCategoriesVisibility();
  }

  clearSearch() {
    this.searchInput.value = "";
    this.isSearchActive = false;
    this.hideClearButton();
    this.showSearchButton();
    this.hideNoResults();

    // Показываем элементы
    this.showItems();
  }

  showItems() {
    this.documentsItems.forEach((item) => {
      item.style.display = "flex";
    });

    // Показываем все категории при сбросе поиска
    this.showAllCategories();
  }

  showClearButton() {
    this.clearButton.style.display = "flex";
  }

  hideClearButton() {
    this.clearButton.style.display = "none";
  }

  showSearchButton() {
    this.searchButton.style.display = "flex";
  }

  hideSearchButton() {
    this.searchButton.style.display = "none";
  }

  updateCategoriesVisibility() {
    this.documentsCategories.forEach((category) => {
      const categoryItems = category.querySelectorAll(
        `.${SELECTORS.DOCUMENTS_ITEMS}`,
      );
      const hasVisibleItems = Array.from(categoryItems).some(
        (item) => item.style.display !== "none",
      );

      if (hasVisibleItems) {
        category.style.display = "block";
      } else {
        category.style.display = "none";
      }
    });
  }

  showAllCategories() {
    this.documentsCategories.forEach((category) => {
      category.style.display = "block";
    });
  }

  createNoResultsElement() {
    // Проверяем, не существует ли уже элемент
    const existingElement = document.querySelector(`.${SELECTORS.NO_RESULTS}`);
    if (existingElement) {
      this.noResultsElement = existingElement;
      return;
    }

    this.noResultsElement = document.createElement("div");
    this.noResultsElement.className = SELECTORS.NO_RESULTS;
    this.noResultsElement.innerHTML = `
      <p>К сожалению, ничего не найдено</p>
    `;
    this.noResultsElement.style.display = "none";

    // Вставляем элемент после списка DOCUMENTS
    const documentsList = document.querySelector(".documents__list");
    if (documentsList && documentsList.parentNode) {
      documentsList.parentNode.insertBefore(
        this.noResultsElement,
        documentsList.nextSibling,
      );
    }
  }

  showNoResults() {
    if (this.noResultsElement) {
      this.noResultsElement.style.display = "flex";
    }
  }

  hideNoResults() {
    if (this.noResultsElement) {
      this.noResultsElement.style.display = "none";
    }
  }
}

document.addEventListener("DOMContentLoaded", function () {
  new DocumentsSearch();
});
